import { jwtDecode } from 'jwt-decode';

// 🔥 tipagem do seu token
export interface JwtPayload {
  idempresa: string;
  iduser: string;
  banco: string;
  tipoimp: number;
  refs: boolean;
  img: string;
  decimais: number;
  margem: number;
  est: boolean;
  // Código de Regime Tributário da empresa (1 = Simples Nacional, 3 = Regime
  // Normal) — usado pra decidir CSOSN x CST no cadastro de produtos (ver
  // DetalheDeProduto.tsx/DialogCadastrarProd.tsx), mesmo critério que o
  // backend já usa pra montar a NFC-e/NFe (GeraNFCe.ts/GeraNfe.ts).
  crt: number;
  iat: number;
  exp: number;
}

// 🔥 cache tipado
let authCache: JwtPayload | null = null;

// 🔥 carrega e salva no cache
export const loadAuth = (): JwtPayload | null => {
  const token = localStorage.getItem('APP_ACCESS_TOKEN');
  
  if (!token) {
    authCache = null;
    return null;
  }

  try {
    authCache = jwtDecode<JwtPayload>(token);
    return authCache;
  } catch {
    authCache = null;
    return null;
  }
};

// 🔥 pega do cache (rápido)
export const getAuth = (): JwtPayload | null => {
  return authCache;
};